import { Modal, Button } from "react-bootstrap";

interface RestoreModalProps {
  show: boolean;
  onHide: () => void;
  entityName: string;
  onRestore: () => void;
}

export function RestoreModal({
  show,
  onHide,
  entityName,
  onRestore,
}: RestoreModalProps) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Restaurar {entityName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        O {entityName.toLowerCase()} informado já foi utilizado anteriormente,
        mas está inativo. Deseja restaurá-lo?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={onRestore}>
          Restaurar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
